/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */

export type InteractionSubjectType =
  (typeof InteractionSubjectType)[keyof typeof InteractionSubjectType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InteractionSubjectType = {
  contact: 'contact',
  company: 'company',
  deal: 'deal'
} as const;
